var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M789 551L789 579",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 789.5,
    cy: 546.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M784.987 546.19C784.987 542.283 788.288 539.117 792.358 539.117C792.943 539.117 793.511 539.184 794.056 539.308C792.742 538.48 791.187 538 789.519 538C784.814 538 781 541.806 781 546.5C781 551.194 784.814 555 789.519 555C791.814 555 793.895 554.093 795.427 552.62C794.492 553.032 793.454 553.263 792.358 553.263C788.288 553.263 784.987 550.096 784.987 546.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M798.402 545.6L798.37 543.146L796.535 544.719L794.304 544.056L795.112 546.337L793.765 548.381L796.1 548.218L797.499 550.144L798.133 547.763L800.345 546.909L798.402 545.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.780782478f9f443ba79a93b87f428cf5.svg";
export { ForwardRef as ReactComponent };